import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';

window.onerror = function(msg, src, line, col, err) {
  document.body.innerHTML = '<div style="padding:20px;font-family:monospace;font-size:12px;background:red;color:white;word-break:break-all;">' +
    '<b>ERROR:</b><br/>' + msg + '<br/><br/>' +
    '<b>Source:</b> ' + src + '<br/>' +
    '<b>Line:</b> ' + line + '<br/><br/>' +
    '<b>Stack:</b><br/>' + (err && err.stack ? err.stack : 'none') +
    '</div>';
};

window.addEventListener('unhandledrejection', function(e) {
  document.body.innerHTML = '<div style="padding:20px;font-family:monospace;font-size:12px;background:red;color:white;word-break:break-all;">' +
    '<b>UNHANDLED PROMISE:</b><br/>' + (e.reason && e.reason.stack ? e.reason.stack : String(e.reason)) +
    '</div>';
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
